<app-main-pages-container>
    <section>
        <h1>
            {{ 'rules_header' | translate }}
        </h1>
        <ol>
            <li>
                {{ 'rules_p1_1' | translate }}
                <a routerLink="/">{{ domain }}</a>
                {{ 'rules_p1_2' | translate }}
            </li>
            <ol>
                <li>
                    {{ 'rules_p2' | translate }}
                </li>
                <li>
                    {{ 'rules_p3' | translate }}
                </li>
                <li>
                    {{ 'rules_p4' | translate }}
                </li>
                <li>
                    {{ 'rules_p5' | translate }}
                </li>
            </ol>
            <br/>
            <li>
                {{ 'rules_p6' | translate }}
            </li>
            <ol>
                <li>
                    {{ 'rules_p7' | translate }}
                </li>
                <li>
                    {{ 'rules_p8' | translate }}
                </li>
                <li>
                    {{ 'rules_p9' | translate }}
                </li>
            </ol>
            <br/>
            <li>
                {{ 'rules_p10_1' | translate }}
                <a routerLink="/">{{ domain }}</a>
                {{ 'rules_p10_2' | translate }}
            </li>
            <ol>
                <li>
                    {{ 'rules_p11' | translate }}
                </li>
                <li>
                    {{ 'rules_p12' | translate }}
                </li>
                <li>
                    {{ 'rules_p13' | translate }}
                </li>
                <li>
                    {{ 'rules_p14' | translate }}
                </li>
                <li>
                    {{ 'rules_p14_1' | translate }}
                </li>
                <li>
                    {{ 'rules_p15' | translate }}
                </li>
                <li>
                    {{ 'rules_p16' | translate }}
                </li>
                <li>
                    {{ 'rules_p17' | translate }}
                </li>
                <li>
                    {{ 'rules_p18' | translate }}
                </li>
                <li>
                    {{ 'rules_p19' | translate }}
                </li>
                <li>
                    {{ 'rules_p20' | translate }}
                </li>
                <li>
                    {{ 'rules_p21' | translate }}
                </li>
                <li>
                    {{ 'rules_p22' | translate }}
                </li>
                <li>
                    {{ 'rules_p23' | translate }}
                </li>
                <li>
                    {{ 'rules_p24' | translate }}
                </li>
            </ol>
            <br/>
            <li>
                {{ 'rules_p25' | translate }}
            </li>
            <ol>
                <li>
                    {{ 'rules_p26' | translate }}
                </li>
                <li>
                    {{ 'rules_p27' | translate }}
                </li>
            </ol>
            <br/>
            <li>
                {{ 'rules_p28' | translate }}
            </li>
            <ol>
                <li>
                    {{ 'rules_p29' | translate }}
                </li>
                <li>
                    {{ 'rules_p30' | translate }}
                </li>
            </ol>
            <br/>
            <li>
                {{ 'rules_p31_1' | translate }}
                <a routerLink="/rules">{{ domain }}/rules</a>
                {{ 'rules_p31_2' | translate }}
            </li>
        </ol>
    </section>

    <button mat-flat-button routerLink="">{{ 'home' | translate }}</button>
</app-main-pages-container>
